module.exports = __webpack_public_path__ + "img/hoslogo11.82181716.png";